<template>
  <v-app>
    <v-content>
      <GUI/>
    </v-content>
  </v-app>
</template>

<script>
import GUI from './components/GUI'

export default {
  name: 'App',
  components: {
    GUI
  },
  data: () => ({
    //
  })
}
</script>
<style lang="scss">
  body {
    margin: 10px;
  }
</style>
